import { render } from "./LocalRoster.vue?vue&type=template&id=4fc85d06&ts=true"
import script from "./LocalRoster.vue?vue&type=script&lang=ts"
export * from "./LocalRoster.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__